// $(".color-selector").click(function(){
//     $(this).parent(".product-color-selector").find(".color-selector__overlay").toggleClass("visible");
//     $(this).parent(".product-color-selector").find(".color-selector__overlay").find(".color-selector__options").toggleClass("visible");
// });

// $(".color-selector__options .color-selector__close").click(function(){
//     $(this).parent(".color-selector__options").parents(".color-selector__overlay").removeClass("visible");
//     $(this).parent(".color-selector__options").removeClass("visible");
// });
 
// $('.color-selector__option').click(function(){
// $('.color-selector__close').trigger('click');
// });

// $('#shopify-block-fae053ec-6658-4853-a88d-5ddc4c12d986 .grid-active').each(function(){
  if($('#shopify-block-fae053ec-6658-4853-a88d-5ddc4c12d986 .grid-active').find("#grid").length) {
//     $('#shopify-block-fae053ec-6658-4853-a88d-5ddc4c12d986').addClass('new-main-col');
    alert("ok");
  }
  
  
//language switcher
var trigger = $('.language_selector');
var list = $('.languages');

trigger.click(function() {
    trigger.toggleClass('active');
    list.toggle();
});

// this is optional to close the list while the new page is loading
list.click(function() {
    trigger.click();
});



//mobile_language

var trigger_mb = $('.language_selector_mb');
var list_mb = $('.languages_mb');

trigger_mb.click(function() {
    trigger_mb.toggleClass('active');
    list_mb.toggle();
});

// this is optional to close the list while the new page is loading
list_mb.click(function() {
    trigger_mb.click();
});


  $('a').click(function (e) {
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top
        }, 500);
    });












